import http from './api'

const route = 'app/volumepreco/'

export default {
  showDadosVolumeXPrecoMedio: (dataInicial, dataFinal, empresas, cidades, areas, vendedores, redes, produtos, linhas, tokenContrato, segmento) => {
    return http.post(route + 'showDadosVolumeXPrecoMedio', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresas,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      produtos: produtos,
      linhas: linhas,
      tokenContrato: tokenContrato,
      segmento: segmento,
    })
  },
}
